export const ApiQueryKey = {
	productTypes: 'product-types',
	offers: 'offers',
	productTypeVariations: 'product-type-variations',
	admins: 'admins',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	accessories: 'accessories',
	accessoryCategories: 'accessory-categories',
	accessoryNameOverrides: 'accessory-name-overrides',

	assets: 'assets',
	roles: 'roles',
	content: 'content',

	products: 'products',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
